import { yupResolver } from '@hookform/resolvers/yup';
import CloseIcon from '@mui/icons-material/Close';
import { Box, Grid, List, Stack, styled } from '@mui/material';
import { useEffect, useState } from 'react';
import { FieldValues, FormProvider, useForm } from 'react-hook-form';
import {
  Item,
  SearchBar,
  WsButton,
  WsColors,
  WsTypoColors,
  WsTypography,
  WsTypoVariants,
} from 'wisestep-base';
import { object, string } from 'yup';

import { useNewEmailStore } from '../Util/NewEmailStore';

import { SearchEmailContent } from './components/SearchEmailContent';
import { SearchListItem } from './components/SearchListItem';
import useSearch, { ImapSearchResponse } from './hooks/useSearch';
const ModalBox = styled(Box)({
  position: 'absolute' as const,
  width: '90vw',
  height: '90vh',
  top: '50%',
  left: '50%',
  transform: 'translate(-50%, -50%)',
});
const SearchBarContainer = styled(Item)(({ theme }) => ({
  paddingTop: theme.spacing(0.5),
  paddingBottom: theme.spacing(0.5),
  paddingLeft: theme.spacing(0),
  paddingRight: theme.spacing(0),
}));
interface SearchEmailsProps {
  closeDialog: () => void;
}
const SearchEmails = ({ closeDialog }: SearchEmailsProps) => {
  const validationSchema = object().shape({
    search: string().required('Search is required'),
  });
  const configuredImapAccounts = useNewEmailStore((state) => state.configuredImapAccounts);
  const [query, setQuery] = useState<string>('');
  const [searchResults, setSearchResults] = useState<ImapSearchResponse[]>();
  const searchResponse = useSearch(query, configuredImapAccounts[0].recruiterEmail ?? '');

  const [selectedEmail, setSelectedEmail] = useState<ImapSearchResponse>({
    id: 'string',
    from: 'string',
    fromName: null,
    to: [''],
    cc: null,
    bcc: null,
    subject: 'string',
    body: 'string',
    createdOn: 'string',
    attachments: [],
  });

  useEffect(() => {
    if (searchResponse) {
      setSearchResults(searchResponse);
      setSelectedEmail(searchResponse[0]);
    }
  }, [searchResponse]);

  const formOptions = {
    resolver: yupResolver(validationSchema),
  };
  const methods = useForm(formOptions);
  const { handleSubmit } = methods;

  const submitAction = (data: FieldValues) => {
    setQuery(data.search);
  };
  return (
    <ModalBox borderRadius={1.5} bgcolor={WsColors.White} p={1}>
      <Stack direction={'row'} bgcolor={WsColors.TertiaryShades50} justifyContent={'space-between'}>
        <Item>
          <WsTypography color={WsTypoColors.BLACK} variant={WsTypoVariants.SUB_TITLE}>
            Search
          </WsTypography>
        </Item>
        <Item>
          <CloseIcon onClick={() => closeDialog()} sx={{ cursor: 'pointer' }}></CloseIcon>
        </Item>
      </Stack>

      <Grid sx={{ overflowY: 'auto' }} component="form" container>
        <FormProvider {...methods}>
          <Grid
            columnSpacing={1}
            marginTop={2}
            marginLeft={0.5}
            container
            direction="row"
            item
            xs={12}
            borderRadius={1.5}
          >
            <Grid sx={{ boxShadow: '1px 1px 1px 1px ' + WsColors.BorderGrey }} xs={11} item>
              <SearchBarContainer>
                <SearchBar
                  placeholder="from:john@gmail.com subject:Test Subject Hello John"
                  name="search"
                />
              </SearchBarContainer>
            </Grid>
            <Grid alignItems={'center'} xs={1} item>
              <SearchBarContainer>
                <WsButton onClick={handleSubmit(submitAction)} variant="contained" type="submit">
                  Search
                </WsButton>
              </SearchBarContainer>
            </Grid>
          </Grid>
        </FormProvider>

        <Grid marginTop={1} item container direction="row">
          <Grid item maxHeight="70vh" xs={4} sx={{ overflowY: 'auto' }}>
            <List
              sx={{
                bgcolor: 'background.paper',
                borderColor: 'text.primary',
              }}
            >
              {searchResults?.map((result, index) => (
                <>
                  <SearchListItem
                    email={result}
                    index={index}
                    onMailItemClick={(email) => {
                      setSelectedEmail(email);
                    }}
                    selectedEmail={selectedEmail}
                  />
                </>
              ))}
            </List>
          </Grid>
          <Grid item xs={8} maxHeight="70vh" sx={{ overflowY: 'auto' }}>
            {selectedEmail && (
              <SearchEmailContent
                emailContent={selectedEmail}
                configuredAccount={configuredImapAccounts[0]}
              />
            )}
          </Grid>
        </Grid>
      </Grid>
    </ModalBox>
  );
};

export default SearchEmails;
